var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toggle-check flex items-center space-x-2 mt-4"},[_c('button',{staticClass:"toggle-check--button relative inline-flex items-center cursor-pointer rounded-full h-7 w-12 disabled:cursor-not-allowed disabled:opacity-50 transition-colors",class:{
      'bg-primary': _vm.value,
      'bg-gray-200': !_vm.value
    },attrs:{"disabled":_vm.disabled,"aria-checked":_vm.value},on:{"click":_vm.toggle}},[_c('span',{staticClass:"transition-transform inline-block h-5 w-5 bg-white rounded-full",class:{
        'translate-x-1': !_vm.value,
        'translate-x-6': _vm.value
      }})]),_vm._v(" "),_c('span',{staticClass:"text-base text-gray-700"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }